import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Dashboard/Dashboard.css'
import './invoice.css'
import CustomTable from '@/product/components/molecules/CustomTable'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CartContext from '@/product/context/cart/cartContext'

import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import InvoiceView from './view'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import PaymentManage from './PaymentManage'
import { mapData, dateTimeFormatFunction } from '@/product/common/components'
import RefundInvoice from '@/custom/components/organisms/RefundInvoice'
import * as Yup from 'yup'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory, withRouter } from 'react-router-dom'
import moment from 'moment'

const Invoice = (props) => {
    const reportContext = useContext(ReportContext)
    const invoiceContext = useContext(InvoiceContext)
    const cartContext = useContext(CartContext)
    const [isLoading, setIsLoading] = useState(true)
    const { getAllExportDownload } = reportContext

    const {
        all_invoices,
        getAllInvoices: fetchAllInvoices,
        changeProductStatus,
        invoiceAction,
        responseStatus: responseStatusInvoice,
    } = invoiceContext
    const { responseStatus: responseStatusCart } = cartContext

    const history = useHistory()
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }

    const [changeStatus, setChangeStatus] = React.useState(false)
    const [randomValue, setRandomValue] = useState(null)

    // every call gets a new random value; only the response carrying the latest one is shown
    const getAllInvoices = (formData) => {
        const randomVariable = Math.random()
        setRandomValue(randomVariable)
        // snapshot: formik.values is mutated in place on every tab switch
        return fetchAllInvoices(
            JSON.parse(JSON.stringify(formData)),
            randomVariable
        )
    }
    const [invoiceNotesStatus, setInvoiceNotesStatus] = React.useState(false)
    const [invoiceUnpaidStatus, setInvoiceUnpaidStatus] = React.useState(false)
    const [invoiceCancelApproveStatus, setInvoiceCancelApproveStatus] =
        React.useState(false)

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageCredits, setManageCredits] = useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageRefund, setManageRefund] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        if (popup && status != '') {
            handleRedirectInternal(history, `invoice/view/${id}/${sid}`)
            // setManage({ popup, status, id, sid })
        } else {
            setManage({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const toggleCreditsPopup = (popup, status, id, sid) => {
        if (popup) {
            setManageCredits({ popup, status, id, sid })
        } else {
            setManageCredits({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const toggleRefundPopup = (popup, status, data) => {
        if (popup) {
            setManageRefund({ popup, status, data })
        } else {
            setManageRefund({
                popup,
                status: status ? status : 'new',
                data: null,
            })
        }
    }

    const changeChangeStatus = () => {
        if (changeStatus) formikSelection.resetForm()
        setChangeStatus(!changeStatus)
    }

    const toggleInvoiceModal = () => {
        setInvoiceNotesStatus(!invoiceNotesStatus)
    }

    const toggleUnpaidExpiryModal = () => {
        setInvoiceUnpaidStatus(!invoiceUnpaidStatus)
    }

    const toggleCancelApproveModal = () => {
        setInvoiceCancelApproveStatus(!invoiceCancelApproveStatus)
    }

    let action = props.match.params?.action
        ? props.match.params.action
        : props.match.params
    let auctionId = props.match.params?.id ? props.match.params.id : 0

    const [tableBody, setTableBody] = useState([])
    const [tableData, setTableData] = useState({ records: [], totalRecords: 0 })

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                action: {
                    value: action
                        ? action == 'expired'
                            ? 'unpaid'
                            : action.toString()
                        : null,
                    type: 'in',
                    field: 'b.paid',
                },
                actionlot: {
                    value: auctionId ? auctionId : null,
                    type: 'in',
                    field: 'ac.id',
                },
                active: {
                    value: 2,
                    type: 'in',
                    field: 'b.active',
                },
                expired: {
                    value: 1,
                    type: action == 'expired' ? 'in' : 'notin',
                    field: 'b.seller_expired',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'b.common_invoice',
                },
                fromdate: {
                    value: '',
                    type: 'like',
                    field: 'b.paid_date',
                },
                todate: {
                    value: '',
                    type: 'like',
                    field: 'b.paid_date',
                },
                first_name: {
                    value: '',
                    type: 'like',
                    field: 'u.first_name',
                },
                last_name: {
                    value: '',
                    type: 'like',
                    field: 'u.last_name',
                },
                email: {
                    value: '',
                    type: 'like',
                    field: 'u.email',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllInvoices(values)
        },
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            notes: '',
        },
        validationSchema: Yup.object({
            notes: Yup.string().when('action', {
                is: 'cancel',
                then: Yup.string().required('Required!'),
            }),
        }),
        onSubmit: (values) => {
            if (
                values.action === 'paid' ||
                values.action === 'draft' ||
                values.action === 'cancel'
            ) {
                return changeProductStatus(values)
            } else {
                return assignAuctionLot(values)
            }
        },
    })

    const formikNotesSelection = useFormik({
        initialValues: {
            unpaid_expiry_hours: '',
        },
        validationSchema: Yup.object({
            invoice_notes: Yup.string().required('Required'),
        }),
        onSubmit: (values) => {},
    })

    const formikUnpaidSelection = useFormik({
        initialValues: {
            unpaid_expiry_at: '',
            id: 0,
        },
        validationSchema: Yup.object({
            unpaid_expiry_at: Yup.string()
                .required('Required')
                .test(
                    'is-future-date',
                    'Date and time must be in the future',
                    function (value) {
                        if (!value) return false

                        const inputDate = moment(
                            value,
                            'DD-MM-YYYY h:mm A',
                            true
                        )
                        const now = moment()

                        return inputDate.isValid() && inputDate.isAfter(now)
                    }
                ),
        }),
        onSubmit: (values) => {
            if (values.id) {
                values.seller_expired = 0
                values.unpaid_expiry_at = moment(
                    values.unpaid_expiry_at,
                    'DD-MM-YYYY h:mm A'
                ).format()

                return invoiceAction(values, 'unpaidHoursAuction')
            }
        },
    })

    const formikCancelApprove = useFormik({
        initialValues: {
            id: 0,
            admin_approved_relist: 1,
        },
        onSubmit: (values) => {
            if (values.id) {
                return invoiceAction(values, 'cancelApproveRelist')
            }
        },
    })

    useEffect(() => {
        if (all_invoices && all_invoices?.from === randomValue) {
            setTableData(all_invoices)
            setTableBody(
                all_invoices.records.length ? all_invoices.records : []
            )
            setIsLoading(false)
        }
    }, [all_invoices])

    useEffect(() => {
        setTableBody([])
        setTableData({ records: [], totalRecords: 0 })
        setIsLoading(true)
        formik.values.filters.action.value =
            action == 'expired' ? 'unpaid' : action
        formik.values.filters.expired.type =
            action === 'expired' ? 'in' : 'notin'
        // formik.values.filters.expired.value = action == 'expired' ? 1 : 0
        formik.values.page = 1
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        if (action === 'all') {
            formik.values.filters.active.type = 'all'
        } else {
            formik.values.filters.active.type =
                action === 'cancel' ? 'in' : 'notin'
            formik.values.filters.active.value = 2
        }

        getAllInvoices(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        if (manageRefund.status === 'refresh') {
            getAllInvoices(formik.values)
        }
    }, [manageRefund])

    const onClickView = (id, sid, type) => {
        toggleFullScreenPopup(true, type, id, sid)
    }

    const onEditNotes = () => {
        toggleInvoiceModal(true)
    }

    const onClickEdit = (id, secondaryID, type) => {
        toggleCreditsPopup(true, type, id, secondaryID)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.resetForm({
            values: {
                ...formikSelection.initialValues,
                action,
                project_id: data,
            },
        })
        if (action === 'paid' || action === 'draft' || action === 'cancel') {
            setChangeStatus(true)
        }
    }

    const onClickUpdateTime = (buynow_id, buynow) => {
        formikUnpaidSelection.values.id = buynow_id

        formikUnpaidSelection.values.unpaid_expiry_at =
            dateTimeFormatFunction(buynow)
        toggleUnpaidExpiryModal()
    }

    const onClickCancelInvoice = (id) => {
        formikCancelApprove.values.id = id
        toggleCancelApproveModal()
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'visibility',
                clickType: 'view',
                onclick: onClickView,
                tooltipTitle: 'View invoice',
            },
            // {
            //     buttonType: 'description',
            //     clickType: 'view',
            //     onclick: onEditNotes,
            //     tooltipTitle: 'Add invoice notes',
            // },
        ]
        if (action === 'unpaid' || action === 'expired') {
            actionPush.push({
                buttonType: 'update',
                clickType: 'edit',
                onclick: onClickUpdateTime,
                secondaryClickID: 'unpaid_expiry_at',
                clickID: 'id',
                tooltipTitle: 'Time Extend',
            })
        }
        if (action === 'unpaid' || action === 'draft') {
            actionPush.push({
                buttonType: 'monetization_on',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Make payment',
            })
        }
        if (action === 'paid') {
            actionPush.push({
                buttonType: 'undo',
                clickType: 'edit',
                onclick: onClickRefundInvoice,
                tooltipTitle: 'Refund Invoice',
                clickID: 'common_invoice',
                secondaryClickID: 'user_id',
            })
        }

        if (action === 'expired') {
            actionPush.push({
                buttonType: 'cancel',
                clickType: 'edit',
                onclick: onClickCancelInvoice,
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'admin_approved_relist',
                        key2: '0',
                        notation: '===',
                        // String comparison: the DB may return 0 as a number or '0'
                        isString: true,
                    },
                },
                secondaryClickID: '',
                clickID: 'id',
                tooltipTitle: 'Cancel Invoice',
            })
        }
        return actionPush
    }

    const onClickRefundInvoice = (id, secondaryID) => {
        toggleRefundPopup(true, 'view', {
            id,
            user_id: secondaryID,
            projects_shipping: 'shipEngine',
        })
    }

    const tableValues = [
        {
            field: 'common_invoice',
            type: 'hyperlink',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
            click: true,
            onclick: onClickInvoiceEdit,
            clickID: 'common_invoice',
            secondaryClickID: 'user_id',
            clickType: 'edit',
            filterable: true,
        },
        // {
        //     field: 'total_items',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Items',
        //     filterable: true,
        // },
        {
            field: 'total_amount',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Amount',
            filterable: true,
        },
    ]
    if (action === 'paid') {
        tableValues.push({
            field: 'paid_amount',
            type: 'price',
            firstChild: false,
            disablePadding: false,
            label: 'Paid Amount',
            filterable: true,
        })
    }

    tableValues.push(
        {
            field: 'users_first_name,users_last_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User/Company',
            filterable: true,
        },
        {
            field: 'users_email',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Email',

            filterable: true,
        },
        //date_added
        {
            field: 'date_added',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
            filterable: true,
        }
    )

    if (action === 'cancel') {
        tableValues.push({
            field: 'returned_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Cancel Date',
        })
        tableValues.push({
            field: 'emp_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Employee name',
        })
    }

    if (action === 'paid') {
        tableValues.push({
            field: 'paid_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Paid Date',
        })
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickID: 'common_invoice',
        secondaryClickID: 'user_id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const tableActions = []

    if (action === 'paid') {
        tableActions.push({
            label: 'Move to Unpaid',
            icon: <span className="material-icons">low_priority</span>,
            onclick: onSelectMultiProducts,
            type: 'draft',
        })
    } else if (action === 'unpaid' || action === 'draft') {
        tableActions.push({
            label: 'Move to Paid',
            icon: <span className="material-icons">low_priority</span>,
            onclick: onSelectMultiProducts,
            type: 'paid',
        })
        tableActions.push({
            label: 'Cancel Invoice',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'cancel',
        })
    } else {
        tableActions.push(
            {
                label: 'Move to Unpaid',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'draft',
            },
            {
                label: 'Move to Paid',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'paid',
            }
        )
    }
    let data = [
        {
            label: 'Invoice Number',
            placeholder: 'Enter invoice number',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            filter: true,
        },
        {
            label: 'Created From Date',
            placeholder: 'Date Ending from',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'date',
            name: 'fromdate',
            filter: true,
        },
        {
            label: 'Created To Date',
            placeholder: 'Date Ending To',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'date',
            name: 'todate',
            filter: true,
        },
        {
            label: 'User First Name',
            placeholder: 'Enter First Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'first_name',
            filter: true,
        },
        {
            label: 'User Last Name',
            placeholder: 'Enter Last Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'last_name',
            filter: true,
        },
        {
            label: 'User Email',
            placeholder: 'Enter Email',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'email',
            filter: true,
        },
    ]
    if (auctionId) {
        ;[
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Auction Id',
                placeholder: 'Enter auction number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'actionlot',
                filter: true,
            },
            {
                label: 'Created From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Created To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
            {
                label: 'User First Name',
                placeholder: 'Enter First Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'first_name',
                filter: true,
            },
            {
                label: 'User Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'last_name',
                filter: true,
            },
            {
                label: 'User Email',
                placeholder: 'Enter Email',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'email',
                filter: true,
            },
        ]
    }

    const searchInfo = {
        formik: formik,
        data: data,
    }

    const reasonForCancelInvoice = [
        {
            label: 'Reason *',
            name: 'notes',
            type: 'text',
            placeholder: 'Reason for cancellation',
            formik: formikSelection,
        },
    ]

    const invoiceNotes = [
        {
            label: 'Notes',
            name: 'invoice_notes',
            type: 'textarea',
            placeholder: 'Enter your invoice notes',
            formik: formikNotesSelection,
        },
    ]

    const invoiceExpiry = [
        {
            label: 'Expiry Date',
            name: 'unpaid_expiry_at',
            field: 'unpaid_expiry_at',
            type: 'datetime',
            placeholder: 'Select Expiry Date',
            formik: formikUnpaidSelection,
        },
    ]
    const resetForm = () => {
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
    }

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'productchange'
            ) {
                setChangeStatus(false)
                formikSelection.resetForm()
                getAllInvoices(formik.values)
            }
        }
    }, [responseStatusInvoice])

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'unpaidHoursAuction'
            ) {
                getAllInvoices(formik.values)
                toggleUnpaidExpiryModal()
            }
        }
    }, [responseStatusInvoice])

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'cancelApproveRelist'
            ) {
                getAllInvoices(formik.values)
                toggleCancelApproveModal()
            }
        }
    }, [responseStatusInvoice])

    useEffect(() => {
        if (responseStatusCart) {
            if (responseStatusCart.status === 'success') {
                if (responseStatusCart.from === 'payCartWallet') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                } else if (responseStatusCart.from === 'payCartOffline') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                }
            }
        }
    }, [responseStatusCart])

    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={global?.advFilters ? global?.advFilters : false}
                    resetForm={resetForm}
                />
                <div className="d-flex justify-content-end">
                    <Button
                        id="invoice_report"
                        onClick={() =>
                            getAllExportDownload({
                                action: 'export',
                                order: 'asc',
                                orderby: '',
                                search: 'all',
                                report: `${action}_invoice_management`,
                            })
                        }
                    >
                        <span className="material-icons">get_app</span>Export
                        All Data
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={tableData}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllInvoices}
                />
            </div>
            {/* <InvoiceView data={manage} function={toggleFullScreenPopup} /> */}
            <PaymentManage
                data={manageCredits}
                from={props.from || ''}
                paymentMode={props.paymentMode}
                full_payment={props.full_payment}
                function={toggleCreditsPopup}
            />
            <RefundInvoice data={manageRefund} function={toggleRefundPopup} />
            <CustomDialog
                title={'Change invoice status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                {formikSelection.values.action === 'cancel' &&
                    mapData(reasonForCancelInvoice)}
                <div className="actionWrapper">
                    <Button
                        id="invoice_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="invoice_confirm"
                            type="submit"
                            disabled={
                                formikSelection.isSubmitting || !changeStatus
                            }
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                title="Update unpaid invoice Expiry date"
                open={invoiceUnpaidStatus}
                className="invoiceNotes"
                function={toggleUnpaidExpiryModal}
            >
                {mapData(invoiceExpiry)}
                <div className="actionWrapper">
                    <Button onClick={() => toggleUnpaidExpiryModal()}>
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikUnpaidSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            type="submit"
                            label="Confirm"
                            disabled={
                                formikUnpaidSelection.isSubmitting ||
                                !invoiceUnpaidStatus
                            }
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                title="Cancel Invoice"
                open={invoiceCancelApproveStatus}
                function={toggleCancelApproveModal}
            >
                <h5>
                    Are you sure you want to cancel this invoice? The seller
                    will be approved to relist the product.
                </h5>
                <div className="actionWrapper">
                    <Button onClick={() => toggleCancelApproveModal()}>
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikCancelApprove.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            type="submit"
                            label="Confirm"
                            disabled={
                                formikCancelApprove.isSubmitting ||
                                !invoiceCancelApproveStatus
                            }
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                title="Invoice notes"
                open={invoiceNotesStatus}
                className="invoiceNotes"
                function={toggleInvoiceModal}
            >
                <h5>Add any specific information related to invoices here.</h5>
                {mapData(invoiceNotes)}
                <div className="actionWrapper">
                    <Button onClick={() => toggleInvoiceModal()}>Cancel</Button>
                    <form
                        onSubmit={formikNotesSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default withRouter(Invoice)
